"use strict";

var React = require('react'),
    ReactRouter = require('react-router'),
    BS = require('react-bootstrap'),
    DocumentTitle = require('react-document-title'),
    cx = require('classnames'),
    CurrentUser = require('../../shared/CurrentUser'),
    Constants = require('../../constants'),
    _ = require('underscore'),
    UserSignup = require('../../models/UserSignup'),
    Cmp = require('../../components'),
    Link = require('../../components/Link'),
    Footer = require('./Footer'),
    Validation = require('../../partials/validation');

var Signup = React.createClass({displayName: "Signup",
    mixins: [
        ReactRouter.Navigation
    ],
    contextTypes: {
        router: React.PropTypes.func
    },

    getDefaultProps: function() {
        return {
            model: new UserSignup()
        };
    },

    updateState: function() {
        return {};
    },

    getInitialState: function() {
        return this.updateState();
    },

    componentWillMount: function() {
        this.props.model.clear();
    },

    render: function() {
        var me = this,
            props = me.props,
            userTypes = [{
                id: 'Agent',
                name: 'Agent'
            },{
                id: 'Broker',
                name: 'Broker'
            },{
                id: 'Developer',
                name: 'Developer'
            },{
                id: 'Builder',
                name: 'Builder'
            }],
            isBusinessNameHidden = function(state){ 
                return state.model.type !== 'Builder' && state.model.type !== 'Developer';
            },
            isBrokerageNameHidden = function(state){ 
                return state.model.type !== 'Agent' && state.model.type !== 'Broker';
            },
            inputParams = {
                type: "text",
                trigger: "onChange"
            },
            title = props.title + ' - Signup';

        return (
            React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: title}), 
                React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        React.createElement("div", {className: "col-sm-6 col-sm-offset-3"}, 
                            React.createElement(BS.Panel, {className: "panel-split-header", header: (React.createElement("h2", null, "Signup ", React.createElement("span", null, "or"), " ", React.createElement(Link, {to: "Login", className: "blue-text"}, "Login")))}, 
                                React.createElement(Validation.Form, {horizontal: false, ref: "form", model: this.props.model, onSubmit: this.onSubmit, getMessage: this.getMessage, validateOnLoad: false}, 
                                    React.createElement("div", {className: "row half-gutter"}, 
                                        React.createElement(Validation.Input, React.__spread({},  inputParams, {groupClassName: "col-sm-6", type: "text", placeholder: "First Name:", name: "contactInfo.firstName"})), 
                                        React.createElement(Validation.Input, React.__spread({},  inputParams, {groupClassName: "col-sm-6", type: "text", placeholder: "Last Name:", name: "contactInfo.lastName"}))
                                    ), 
                                    React.createElement(Validation.Input, React.__spread({},  inputParams, {placeholder: "Email Address:", name: "user.email"})), 
                                    React.createElement(Validation.Input, React.__spread({},  inputParams, {type: "password", placeholder: "Password", name: "user.password"})), 

                                    React.createElement("div", {className: "text-center margin-bottom-15"}, "I am a Agent"), 

                                    /*<Cmp.RadioGroup type="radio" name="type" items={userTypes}/>*/

                                    React.createElement(Validation.Input, React.__spread({},  inputParams, {type: "text", formLinks: { hidden: isBusinessNameHidden, required: isBrokerageNameHidden}, groupClassName: "margin-bottom-30", placeholder: "Business Name:", name: "businessName"})), 

                                    React.createElement(Validation.Input, React.__spread({},  inputParams, {formLinks: { hidden: isBrokerageNameHidden, required: isBusinessNameHidden}, groupClassName: "margin-bottom-30", placeholder: "Brokerage Name:", name: "brokerageName"})), 

                                    React.createElement(Cmp.Button.Save, {className: "btn-block"}, "Signup")
                                ), 

                                React.createElement("hr", {className: "clear"}), 

                                React.createElement("div", {className: "text-center"}, 
                                    React.createElement("p", null, "By signing up, you agree to Agent Shields"), 
                                    React.createElement("p", null, React.createElement(Link, {to: "Terms", target: "_blank"}, "Terms and Conditions"))
                                )
                            ), 

                            React.createElement(Footer, {trackerId: "agent-toolbox-signup"})
                        )
                    )
                )
            )
        );
    },

    onSubmit: function(e) {
        var me = this,
            state = me.state,
            props = me.props,
            values = this.refs.form.getValues();

            values.user.username = values.user.email;

        if (this.refs.form.isValid()) {
            props.model.save(values).then(function() {
                me.transitionTo('Login', _.result(Constants, 'query'));
            });
        }
    }        
});
module.exports = Signup;
